"use client";

import Link from "next/link";
import Image from "next/image";
import React from "react";
import { MenuOutlined } from "@ant-design/icons";
import { Drawer, Button, Menu, Dropdown } from "antd";

import unitrendLogo from "@/public/logo-unitrend.png";
import unitrendWhiteLogo from "@/public/logo-unitrend-white.png";

import { ThemeSwitcher } from "./theme-switcher";
import { useMediaQuery } from "@/hooks/use-media-query";
import { useTheme } from "next-themes";
import { usePathname } from "next/navigation";
import { useIsMobile } from "@/hooks/use-mobile";

export const Navbar: React.FC = () => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const isMobile = useIsMobile()
  const { theme } = useTheme();
  const pathname = usePathname();


  const [drawerVisible, setDrawerVisible] = React.useState(false);

  const handleDrawerOpen = () => setDrawerVisible(true);
  const handleDrawerClose = () => setDrawerVisible(false);

  const menuItems = [
    // { key: "media", label: <Link href="/media">Media Monitoring</Link> },
    // { key: "ecommerce", label: <Link href="/ecommerce">E-Commerce</Link> },
    { key: "gdp", label: <Link href="/gdp">GDP Tracker</Link> },
    // { key: "riset", label: <Link href="/riset">Riset Kami</Link> },
    { key: "tentang", label: <Link href="/tentang">Tentang Kami</Link> },
    { key: "kontak", label: <Link href="https://wa.me/6285179583787">Kontak</Link> },
  ];

  const selectedKeys = menuItems.filter((item) => pathname.includes(item.key)).map((item) => item.key)

  if (isMobile)
    return (
      <div className="flex gap-5 px-5 items-center justify-between w-full py-4">
        <Link href={"/"}>
          <div className="hover:cursor-pointer h-[40px] w-28">
            <Image
              src={theme === "dark" ? unitrendWhiteLogo : unitrendLogo}
              alt="Unitrend"
              height={500}
              width={500}
              className="hover:cursor-pointer h-auto w-[100px] place-items-center flex justify-center"
            />
          </div>
        </Link>

        <div className="flex items-center gap-5">
          <ThemeSwitcher />

          <Button
            icon={<MenuOutlined />}
            onClick={handleDrawerOpen}
            type="text"
          />

          <Drawer
            title={
              <Link href={"/"}>
                <div className="hover:cursor-pointer h-[40px] w-28 ml-3">
                  <Image
                    src={theme === "dark" ? unitrendWhiteLogo : unitrendLogo}
                    alt="Unitrend"
                    height={500}
                    width={500}
                    className="hover:cursor-pointer h-auto w-[100px] place-items-center flex justify-center"
                  />
                </div>
              </Link>
            }
            placement="right"
            onClose={handleDrawerClose}
            open={drawerVisible}
          >
            <Menu mode="vertical" items={menuItems} selectedKeys={selectedKeys} />
          </Drawer>
        </div>
      </div>
    );

  return (
    <div className="flex gap-5 items-center w-full px-5 py-4 max-w-7xl mx-auto">
      <Link href={"/"}>
        <div className="hover:cursor-pointer h-[40px] w-28  -mb-2">
          <Image
            src={theme === "dark" ? unitrendWhiteLogo : unitrendLogo}
            alt="Unitrend"
            height={500}
            width={500}
            className="hover:cursor-pointer h-auto w-[100px] place-items-center flex justify-center"
          />
        </div>
      </Link>

      <div className="flex items-center gap-5 w-full">
        <Menu mode="horizontal" items={menuItems} className="w-full" selectedKeys={selectedKeys} style={{ borderBottom: 'none' }} />
        <ThemeSwitcher />
      </div>
    </div>
  );
};
